import Drawer, { IDrawer } from '@atoms/Drawer/Drawer';
import Text from '@atoms/Text/Text';
import { PropsWithChildren, useEffect, useState } from 'react';

export interface IDrawerWrapper extends IDrawer {
  readonly title?: string;
  readonly description?: string;
  readonly wrapperStyles?: string;
}

const DrawerWrapper = ({
  title,
  description,
  isOpen,
  setIsOpen,
  children,
  wrapperStyles = 'tw-px-4 tw-py-10 md:tw-p-12',
  ...rest
}: PropsWithChildren<IDrawerWrapper>) => {
  const [isRtl, setIsRtl] = useState(false);

  useEffect(() => {
    const dir = document.documentElement.getAttribute('dir');
    setIsRtl(dir === 'rtl');
  }, []);

  return (
    <Drawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      animateVerticallyOnMobile
      isRtl={isRtl}
      {...rest}
    >
      <div className="tw-flex tw-h-full tw-w-full tw-flex-col">
        {/* Fixed header */}
        {title && (
          <div className="tw-relative tw-bg-grey-10 tw-px-4 tw-py-6 md:tw-px-12 md:tw-py-10">
            <Text variant="heading-28">{title}</Text>
            {description && <Text variant="body-small">{description}</Text>}
          </div>
        )}

        {/* Scrollable content */}
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-h-[calc(100vh-204px)] tw-w-full md:tw-h-[calc(100vh-116px)]">
          <div className="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-y-lg tw-overflow-y-auto">
            <div className={wrapperStyles}>{children}</div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default DrawerWrapper;
